<template>
  <div>
	<div v-if="!json.init" class="spe-slide-goods-wrap" 
        :style="{
            backgroundColor: commonStyle.usePageBackgroundColor ? commonStyle.bgColor : commonStyle.backgroundColor ,
            backgroundImage: commonStyle.backgroundType == 2 ? `url(${commonStyle.backgroundImage})` : ''
        }"
        :ddt-area="`component_${floorId}`"
        ddt-expose="on"
    >
        <div 
            v-if="headerData.type != 0" 
            class="header" 
            :style="{
                backgroundColor: headerData.backgroundColor,
                backgroundImage: headerData.type == 2 ? `url(${headerData.backgroundImage})` : ''
            }"
            @click="$sys.dict.href(headerData.jumpContent)"
            :data-area="pt()"
            :data-pos="`component_${floorId}_滑动商品组件.header_点击跳转`"
            :data-desc="headerData.jumpContent"
            :dd_name="`${pt()}.component_${floorId}_滑动商品组件.header_点击跳转.${headerData.jumpContent}`"
            :ddt-click="`${pt()}.component_${floorId}_滑动商品组件.header_点击跳转.${headerData.jumpContent}`"
            :ddt-pit="`header_点击跳转`"
            :ddt-src="headerData.jumpContent"
            ddt-expose="on"
        >
        <div v-if="headerData.type == 1">
            <div v-if="headerData.moreText">
                <div class="left"  :style="{color: headerData.titleColor}">
                    {{headerData.title}}
                </div>
                <div class="right" :style="{color: headerData.moreTextColor}" >
                    {{headerData.moreText}}
                    <i class="iconfont">&#xe669;</i>
                </div>
            </div>
            <div v-else class="center" :style="{color: headerData.titleColor}">{{headerData.title}}</div>
        </div>
    
        </div>
        <div class="product-tabs" :style="{ backgroundColor: tabHeader.backgroundColor || abHeader.backgroundDefaultColor }" v-if="tabsData && tabsData.length > 1">
            <div 
                class="tab-item"
                :style="{width: `${100 / tabsData.length}%`}"
                @click="tabChange(index)"
                v-for="(el, index) in tabsData" 
                :key="i"
                :ddt-src="el.title"
                :data-area="pt()"
                :data-pos="`component_${json.floorId}_单行滑动商品组件.tab坑位${index + 1}_点击跳转`"
                :data-desc="el.title"
                :dd_name="`${pt()}.component_${json.floorId}_单行滑动商品组件.tab坑位${index + 1}_点击跳转.${el.title}`"
                :ddt-click="`${pt()}.component_${json.floorId}_单行滑动商品组件.tab坑位${index + 1}_点击跳转.${el.title}`"
                :ddt-pit="`tab坑位${index + 1}_点击跳转`"
                ddt-expose="on"
            >
            <div class="tab-name" :style="getTabStyle(index)">{{ el.title }}</div>
            </div>
        </div>
        <div class="main" id="J-products" v-if="productsData.length">
            <div class="products" :style="{padding: `0px ${commonStyle.margin  ? commonStyle.margin : 20}px`}">
                <div class="product-item" v-for="(item, i) in productsData" :key="i"
                    @click="$sys.dict.href(item.link)"
                    :data-area="pt()"
                    :data-pos="`component_${floorId}_滑动商品组件.单个商品_点击跳转`"
                    :data-desc="item.link"
                    :dd_name="`${pt()}.component_${floorId}_滑动商品组件.单个商品_点击跳转.${item.link}`"
                    :ddt-click="`${pt()}.component_${floorId}_滑动商品组件.单个商品_点击跳转.${item.link}`"
                    :ddt-pit="`单个商品_点击跳转`"
                    :ddt-src="item.link"
                    ddt-expose="on"
                >
                    <div class="top">
                        <img v-lazy="item.imgUrl"/>
                    </div>
                    <div class="bottomn" v-if="item.title || (item.labels && item.labels.length > 0) || item.salePrice || item.originalPrice">
                        <div class="name" v-if="item.title">
                            {{item.title}}
                        </div>
                        <div class="label" v-if="true || item.labels && item.labels.length > 0">
                            <span :class="l.type == 0 ? 'type-one' : 'type-two'" v-for="(l, i) in item.labels" :key="i">{{l.name}}</span>
                        </div>
                        <div class="price" v-if="item.salePrice && columnsType != 2">
                            ￥{{item.salePrice}}
                        </div>
                        <div class="price curve" v-if="item.salePrice && columnsType == 2">
                            <i>￥</i>{{getPriceObj(item.salePrice).integer}}<i>{{getPriceObj(item.salePrice).decimal}}</i>
                        </div>
                        <div class="original" :class="{curve: columnsType == 2}" v-if="item.originalPrice">
                            ￥{{item.originalPrice}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import { priceIntegerDecimal } from  '../assets/js/format'
export default {
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
        },
	},
	components: {},
	data() {
		return {
            floorId: '',
            commonStyle: {},
            headerData: {},
            productsData: [],
            tabsData: [],
            tabHeader: {},
            current: 0,
            columnsType: 0,
        };
	},
    inject: ['pt', 'getProductsInfoData'],
	watch: {
        json: {
            handler(newVal) {
                let { data, floorId } = newVal
                if(!data) {
                    return
                }
                this.floorId = floorId
                let {commonStyle, header, products, tabsData, tabHeader, columnsType} = data
                if(!commonStyle || !header || !products) {
                    return
                }
                this.commonStyle = commonStyle
                this.headerData = header
                this.productsData = products
                this.tabsData = tabsData
                this.tabHeader = tabHeader
                this.columnsType = columnsType
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getPriceObj(price) {
			return priceIntegerDecimal(price)
		},
        async tabChange(index) {
            this.current = index;
            const { products = [] } = await this.getProductsInfoData(this.floorId, this.tabsData[index].id, this.tabsData[index].pids.join(','))
            this.productsData = products
            // tab 切换完成后，重新设置滚动条初始位置
            let element = document.getElementById("J-products");
            element.scrollTo(0, 0);
		},
        getTabStyle(index) {
			const select = this.current == index;
			const tabHeader = this.tabHeader
			let backgroundImage = ''
			if (select) {
				backgroundImage = tabHeader.selectedBackgroundImg ? `url(${tabHeader.selectedBackgroundImg})` : 'none';
				return {
					color: tabHeader.activeColor || tabHeader.activeDefaultColor, 
					backgroundImage, 
					backgroundSize: `cover`,
                    fontWeight: 'bold' 
				}
			} else {
				backgroundImage = tabHeader.titleBackgroundImg ? `url(${tabHeader.titleBackgroundImg})` : 'none'
				return {
					color: tabHeader.color || tabHeader.defaultColor,
					backgroundImage, 
					backgroundSize: `cover` 
				}
			}
		},
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-slide-goods-wrap {
    width: 750px;
    background-size: 100% 100%;
    .header {
        height: 84px;
        line-height: 84px;
        background-size: 100% 100%;
        padding: 0px 30px;
        .left {
            float: left;
            font-size: 34px;
            color: #FFFFFF;
        }
        .right {
            float:right;
            font-size: 24px;
            color: #FFFFFF;
            i {
                font-size: 20px;
            }
        }
        .center{
            font-size: 34px;
            text-align: center;
            color: #FFFFFF;
        }
    }

    .product-tabs {
        width: 100%;
        height: 88px;
        padding: 0 14px;
        display: flex;
        align-items: center;
        overflow-x: hidden;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        box-sizing: border-box;
        &::-webkit-scrollbar {
            display: none;
        }
        .tab-item {
            flex: none;
            .tab-name {
                color: #141414;
                font-size: 28px;
                height: 72px;
                line-height: 72px;
                text-align: center;
                overflow: hidden;
                margin: 0 2px;
                padding: 0 3px;
                border-radius: 16px;
            }
        }
    }
    .main {
        display: flex;
        width: 100%;
        overflow-x: auto;
        /*padding: 10px 0;*/

        .products {
            display: flex;
            .product-item {
                max-height: 496px;
                width: 208px;
                background: #ffffff;
                border-radius: 8px;
                margin-right: 10px;
                padding-bottom: 20px;
                .top {
                    width: 208px;
                    height: 208px;
                    img {
                        width: 208px;
                        height: 208px;
                        border-radius: 8px;
                    }
                }
                .bottomn {
                    padding: 0px 8px;
                    font-size: 0;
                    .name {
                        overflow: hidden;
                        width: 100%;
                        font-size: 26px;
                        color: #5D5F6A;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin: 12px 0px 0px;
                    }
                    .label {
                        height: 34px;
                        display: flex;
                        overflow: hidden;
                        flex-flow: wrap;
                        font-size: 20px;
                        font-weight: 400;
                        margin: 8px 0px 0px;
                        span {
                            border: 1px solid #ff463c;
                            border-radius: 4px;
                            padding: 0px 6px;
                            margin: 0px 4px 10px 0px;
                        }
                        .type-one {
                            color: #ff463c;
                        }
                        .type-two {
                            color: #ffffff;
                            background: #ff463c;
                        }
                    }
                    .price {
                        font-size: 26px;
                        color: #ff463c;
                        line-height: 26px;
                        font-weight: 600;
                        margin: 12px 0px 0px;
                        i {
                            font-size: 22px;
                        }
                        &.curve {
                            background-image: url('https://img62.ddimg.cn/upload_img/00834/h5/bg_price_slide-1681817816.png');
                            background-size: 100% 100%;
                            width: 180px;
                            height: 78px;
                            line-height: 78px;
                            color: #ffffff;
                            text-align: center;
                            margin: 0 auto;
                        }
                    }
                    .original {
                        width: 72px;
                        height: 22px;
                        font-family: PingFangSC-Regular;
                        font-size: 22px;
                        color: #828282;
                        letter-spacing: 0;
                        line-height: 22px;
                        font-weight: 400;
                        text-decoration: line-through;
                        margin: 10px 0px 0px;
                        &.curve {
                            margin: 0 auto;
                        }
                    }
                }
            }
        }
    }
    .main::-webkit-scrollbar {
        display: none;
    }
}
</style>
